import React, { Component } from "react";
import { Link } from "react-router-dom";

class Reports extends Component {
  state = {};
  render() {
    return (
      <React.Fragment>
        <h1 class="container__heading">Reports</h1>
        <p>
          Unlock the full potential of your supply chain with our powerful
          reporting tool. Get valuable insights into your business with a range
          of customizable reports, covering everything from order history to
          supplier performance, and inventory levels to customer behavior. Stay
          informed, make data-driven decisions, and take your business to the
          next level with our reporting tool. Start exploring your data today
          and see the difference it makes.
        </p>
        <h2 class="container__heading report-heading">General</h2>
        <div class="grid grid--1x4 dashboard-stats">
          <div class="card stats">
            <div class="stats__content">
              <h2 class="card__heading stats__heading">
                <Link to="/report/scrap">Scrap Account</Link>
              </h2>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Aspernatur, necessitatibus?
              </p>
            </div>
            <div class="stats__icon"></div>
          </div>
          <div class="card stats">
            <div class="stats__content">
              <h2 class="card__heading stats__heading">
                <Link to="/report/jv">JV Account</Link>
              </h2>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Aspernatur, necessitatibus?
              </p>
            </div>
            <div class="stats__icon"></div>
          </div>
          <div class="card stats">
            <div class="stats__content">
              <h2 class="card__heading stats__heading">
                <Link to="/report/generate-receiveable-report">
                  Receivable Report
                </Link>
              </h2>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Aspernatur, necessitatibus?
              </p>
            </div>
            <div class="stats__icon"></div>
          </div>
          <div class="card stats">
            <div class="stats__content">
              <h2 class="card__heading stats__heading">
                <Link to="/report/generate-payable-report">Payable Report</Link>
              </h2>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Aspernatur, necessitatibus?
              </p>
            </div>
            <div class="stats__icon"></div>
          </div>
          <div class="card stats">
            <div class="stats__content">
              <h2 class="card__heading stats__heading">
                <Link to="/report/general-ledger">Daily Report</Link>
              </h2>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Aspernatur, necessitatibus?
              </p>
            </div>
            <div class="stats__icon"></div>
          </div>
          <div class="card stats">
            <div class="stats__content">
              <h2 class="card__heading stats__heading">
                <Link to="/report/passport-inout">Passport In/Out</Link>
              </h2>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Aspernatur, necessitatibus?
              </p>
            </div>
            <div class="stats__icon"></div>
          </div>
          <div class="card stats">
            <div class="stats__content">
              <h2 class="card__heading stats__heading">
                <Link to="/report/invoices">Invoices</Link>
              </h2>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Aspernatur, necessitatibus?
              </p>
            </div>
            <div class="stats__icon"></div>
          </div>
          <div class="card stats">
            <div class="stats__content">
              <h2 class="card__heading stats__heading">
                <Link to="/report/projects">Projects</Link>
              </h2>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Aspernatur, necessitatibus?
              </p>
            </div>
            <div class="stats__icon"></div>
          </div>
          <div class="card stats">
            <div class="stats__content">
              <h2 class="card__heading stats__heading">
                <Link to="/report/income">Income</Link>
              </h2>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Aspernatur, necessitatibus?
              </p>
            </div>
            <div class="stats__icon"></div>
          </div>
        </div>
        <h2 class="container__heading report-heading">Cheques</h2>
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Vero,
          repellendus.
        </p>
        <div class="grid grid--1x4 dashboard-stats">
          <div class="card stats">
            <div class="stats__content">
              <h2 class="card__heading stats__heading">
                <Link to="/report/cheques/pdc-received">PDC Received</Link>
              </h2>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Aspernatur, necessitatibus?
              </p>
            </div>
            <div class="stats__icon"></div>
          </div>
          <div class="card stats">
            <div class="stats__content">
              <h2 class="card__heading stats__heading">
                <Link to="/report/cheques/pdc-paid">PDC Issued</Link>
              </h2>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Aspernatur, necessitatibus?
              </p>
            </div>
            <div class="stats__icon"></div>
          </div>
        </div>
        <h2 class="container__heading report-heading">Monthly</h2>
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Vero,
          repellendus.
        </p>
        <div class="grid grid--1x4 dashboard-stats">
          <div class="card stats">
            <div class="stats__content">
              <h2 class="card__heading stats__heading">
                <Link to="/report/monthly/room">Room</Link>
              </h2>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Aspernatur, necessitatibus?
              </p>
            </div>
            <div class="stats__icon"></div>
          </div>
          <div class="card stats">
            <div class="stats__content">
              <h2 class="card__heading stats__heading">
                <Link to="/report/monthly/vehicle">Vehicle</Link>
              </h2>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Aspernatur, necessitatibus?
              </p>
            </div>
            <div class="stats__icon"></div>
          </div>
          <div class="card stats">
            <div class="stats__content">
              <h2 class="card__heading stats__heading">
                <Link to="/report/monthly/yard">Yard</Link>
              </h2>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Aspernatur, necessitatibus?
              </p>
            </div>
            <div class="stats__icon"></div>
          </div>
          <div class="card stats">
            <div class="stats__content">
              <h2 class="card__heading stats__heading">
                <Link to="/report/monthly/visa">Visa</Link>
              </h2>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Aspernatur, necessitatibus?
              </p>
            </div>
            <div class="stats__icon"></div>
          </div>
        </div>
        <h2 class="container__heading report-heading">Expiry</h2>
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Vero,
          repellendus.
        </p>
        <div class="grid grid--1x4 dashboard-stats">
          <div class="card stats">
            <div class="stats__content">
              <h2 class="card__heading stats__heading">
                <Link to="/report/expiry/vehicle">Vehicle</Link>
              </h2>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Aspernatur, necessitatibus?
              </p>
            </div>
            <div class="stats__icon"></div>
          </div>
          <div class="card stats">
            <div class="stats__content">
              <h2 class="card__heading stats__heading">
                <Link to="/report/expiry/visa">Visa</Link>
              </h2>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Aspernatur, necessitatibus?
              </p>
            </div>
            <div class="stats__icon"></div>
          </div>
          <div class="card stats">
            <div class="stats__content">
              <h2 class="card__heading stats__heading">
                <Link to="/report/expiry/passport">Passport</Link>
              </h2>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Aspernatur, necessitatibus?
              </p>
            </div>
            <div class="stats__icon"></div>
          </div>
          <div class="card stats">
            <div class="stats__content">
              <h2 class="card__heading stats__heading">
                <Link to="/report/documents-expiry?param=all">Documents</Link>
              </h2>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Aspernatur, necessitatibus?
              </p>
            </div>
            <div class="stats__icon"></div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Reports;
